export default __webpack_public_path__ + "static/media/red_heart.0fd28a6e.png";